import { render, staticRenderFns } from "./CardClass.vue?vue&type=template&id=7c51816a&scoped=true"
import script from "./CardClass.vue?vue&type=script&lang=js"
export * from "./CardClass.vue?vue&type=script&lang=js"
import style0 from "./CardClass.vue?vue&type=style&index=0&id=7c51816a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c51816a",
  null
  
)

export default component.exports